import { render } from "./BlackjackTable.vue?vue&type=template&id=a9384642&scoped=true"
import script from "./BlackjackTable.vue?vue&type=script&lang=js"
export * from "./BlackjackTable.vue?vue&type=script&lang=js"

import "./BlackjackTable.vue?vue&type=style&index=0&id=a9384642&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9384642"]])

export default __exports__